<div class="time-picker" *ngIf="isVisible">
  <bzg-select  [value]="hours" (valueChange)="selectHour($event)" [(value)]="hours" class="ml-8 mr-8">
    <bzg-option *ngFor="let hour of hoursArray" [value]="hour" class="time-picker-select" [ngClass]="{'selected-option': hour === hours}">{{hour}}</bzg-option>
  </bzg-select>
  <span class="separator">:</span>
  <bzg-select  [value]="minutes" (valueChange)="selectMinute($event)" class="ml-8 mr-8">
    <bzg-option *ngFor="let minute of minutesArray" [value]="minute" class="time-picker-select" [ngClass]="{'selected-option': minutes === minute}">{{ minute }}</bzg-option>
  </bzg-select>
  <span class="separator" *ngIf="showSeconds">:</span>
  <bzg-select *ngIf="showSeconds" [value]="seconds" (valueChange)="selectSecond($event)" class="ml-8 mr-8">
    <bzg-option *ngFor="let second of secondsArray" [value]="second" class="time-picker-select" [ngClass]="{'selected-option': seconds === second}">{{ second }}</bzg-option>
  </bzg-select>
  <svg class="bz-icon bz-icon-ml" height="32px" width="32px" *ngIf="showIcon" (click)="confirmAndClose()">
    <use href="#icon-timer"></use>
  </svg>
</div>
